// extracted by mini-css-extract-plugin
export default {"root":"License_root__InR-W"};